import { useDispatch, useSelector } from "react-redux";
import { useForm } from 'react-hook-form';
import { COMMIT, COMMITALL, REPO, HISTORYALL } from "../../services/actions";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import React from "react";
import { Button, Container, Box, Grid, Tab, Tabs, Pagination, Card, Typography, Chip } from "@mui/material";
import Form from './Form';
import ActionBar from "../extra/ActionBar";
import ProjectImg from './project.jpg'
import SearchBar from "../extra/SearchBar";
import { isBase64Image } from "../../libs/Libs";
import XTable from "../extra/XTableAnother";
import MoreInfo from "../extra/MoreInfo";
import { BsCopy } from "react-icons/bs";
import FileUploader from "./FileUpload";
import axios from "axios";
import NoData from "../extra/NoData";

export default function Documents() {
  let auth = useSelector((state) => state?.loginState?.auth)
  let dispatch = useDispatch()
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const getParam = (name) => {
    const clean = (val) => {
      if (!val) return val;
      try {
        return decodeURIComponent(val.replace(/\+/g, ' '));
      } catch (e) {
        return val.replace(/\+/g, ' ');
      }
    };

    try {
      const fullUrl = window.location.href;
      const queryIndex = fullUrl.indexOf('?');
      if (queryIndex !== -1) {
        const queryString = fullUrl.substring(queryIndex + 1);
        const pairs = queryString.split('&');
        for (let pair of pairs) {
          const eqIndex = pair.indexOf('=');
          if (eqIndex !== -1) {
            const key = clean(pair.substring(0, eqIndex).trim());
            if (key === name) {
              return clean(pair.substring(eqIndex + 1).trim());
            }
          }
        }
      }
    } catch (e) {
      console.error("Error parsing URL params:", e);
    }
    return clean(params.get(name));
  };

  const backUrl = getParam("back") || params.get("back");
  const client = getParam("client") || params.get("client");
  const category = getParam("category") || params.get("category");
  const work = getParam("work") || params.get("work");
  const service = getParam("service") || params.get("service");
  const client_name = getParam("client_name") || params.get("client_name");
  const object_id = getParam("object_id") || params.get("object_id");
  const files = getParam("files") || params.get("files");
  const [open, setOpen] = React.useState(false)
  const [defV, setDefV] = React.useState({})
  const [view, setView] = React.useState(1);
  const navigate = useNavigate();
  let { id } = useParams()

  let commitallState = useSelector((state) => state?.commitallState)
  let repoState = useSelector((state) => state?.repoState)

  let user = useSelector((state) => state?.loginState?.auth)
  const [page, setPage] = React.useState(0); // current page  
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchDocs = (id = 0, page = 0) => {
    let qfiles = "";
    try {
      if (files && files !== "undefined") {
        let filesL = JSON.parse(files);
        if (Array.isArray(filesL) && filesL.length > 0) {
          qfiles = `id__in=${JSON.stringify(filesL)}&`;
        }
      }
    } catch (e) {
      console.error("Error parsing files:", e);
    }


    const url = page === 0 ? `repo/documents/${id}/?${qfiles}repository__client_id=${client}&category=${category}&object_id=${object_id || 0}` : `repo/documents/${id}/?page=${page}`;
    dispatch({ type: `${COMMITALL}_GET`, payload: url });
  }

  const fetchRepos = (id = 0) => {
    dispatch({ type: `${REPO}_GET`, payload: `repo/${id}/` });
  }

  React.useEffect(() => {
    console.log("USER", auth)
    try {
      fetchDocs(id, 0);
      fetchRepos(id)
    } catch (err) {
    }
  }, [id])


  React.useEffect(() => {
    try {
      if (!open) {
        fetchDocs(id, 0);
      }
    } catch (err) {
    }
  }, [open])

  React.useEffect(() => {
    fetchDocs(id, page);
  }, [page]);


  // Handle filter search
  const handleSearch = (key, value) => {
    const query = `project/0/?filter_by={"${key}__istartswith":"${value}"}`;
    dispatch({ type: `${COMMITALL}_GET`, payload: query });
  };
  const tableHeadings = ["ID", "image", "Project Name", "Company Name", "Country", "Duration", "Camera Count"];
  const tableRows = commitallState?.data?.results?.map((project) => ({
    id: project.id,
    image: project.project_image,
    project_name: project.project_name,
    company_name: project.company_name,
    country: project.country,
    duration: project.duration,
    camera_count: project.camera_count,
  }));

  const handleDelete = (id) => {
    dispatch({ type: `${COMMIT}_DELETE`, payload: id });
  };

  const downloadFile = async (docId, commitId, filename) => {

    const response = await axios.get(
      `https://repo.plakal.in/api/download/${docId}?commit_id=${commitId}`,
      {
        responseType: "blob"
      }
    );

    const disposition = response.headers["content-disposition"];

    // let filename = commitId;

    if (disposition) {
      const match = disposition.match(/filename="(.+)"/);
      if (match) filename = match[1];
    }

    const blob = new Blob([response.data], {
      type: response.headers["content-type"]
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;
    link.download = filename;

    document.body.appendChild(link);

    link.click();

    link.remove();

    window.URL.revokeObjectURL(url);
  };

  const getHistory = (docId) => {
    let url = `file_history/${docId}/`
    const queryString = new URLSearchParams(params).toString();
    let bkUrl = `/repository/documents/0?${queryString}&back=${backUrl}`
    dispatch({
      type: `${HISTORYALL}_GET`, payload: url, callback: (res) => {
        console.log(res)
        navigate(`/history/`, {
          state: {
            data: res,
            prevNav: bkUrl
          }
        });
      }
    });
  }

  return (
    <>

      {open ? <FileUploader
        commit={defV}
        back={() => { setOpen(false) }}
      />
        : <Container maxWidth="false" className="py-3">
          <ActionBar
            showGrid={[2, 5]}
            onBtnClick={(type, col) => {
              if (type === "grid") {
                setView(1);
              }
              if (type === "tabular") {
                setView(2);
              }
            }}
            hasPermission={user.permissions.includes('commit.add_commit')}
            label="Documents"
            setOpen={(s) => {
              setDefV({});
              setOpen(true);
            }}
            btnLabel={user.permissions.includes('commit.add_commit') ? "ADD REPOSITORY" : null} 
          />

          <Box sx={{ my: 2.5, width: '100%' }}>
            <SearchBar bylist={[{ key: "original_filename", label: "File Name" }, { key: "commit_message", label: "Commit Message" }]} handleSearch={handleSearch} />
          </Box>

          {view === 1 && (
            <>
              <Box 
                sx={{ 
                  p: 3, 
                  mb: 3, 
                  borderRadius: '16px', 
                  bgcolor: '#ffffff', 
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.03)',
                  display: 'flex', 
                  flexDirection: { xs: 'column', lg: 'row' },
                  alignItems: { xs: 'stretch', lg: 'center' }, 
                  justifyContent: 'space-between',
                  gap: 3
                }}
              >
                <Box 
                  sx={{ 
                    flex: 1, 
                    display: 'grid', 
                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(4, minmax(0, 1fr))' }, 
                    gap: 3 
                  }}
                >
                  <Box sx={{ minWidth: 0 }}>
                    <Typography fontSize={11} sx={{ color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 700, mb: 0.5 }}>
                      Client
                    </Typography>
                    <Typography fontSize={14} fontWeight={800} color="#0f172a" lineHeight={1.4} sx={{ wordBreak: 'break-word' }}>
                      {client_name || "—"}
                    </Typography>
                  </Box>

                  <Box sx={{ minWidth: 0 }}>
                    <Typography fontSize={11} sx={{ color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 700, mb: 0.5 }}>
                      Service
                    </Typography>
                    <Typography fontSize={14} fontWeight={700} color="#1e293b" lineHeight={1.4} sx={{ wordBreak: 'break-word' }}>
                      {service || "—"}
                    </Typography>
                  </Box>

                  <Box sx={{ minWidth: 0 }}>
                    <Typography fontSize={11} sx={{ color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 700, mb: 0.5 }}>
                      Work
                    </Typography>
                    <Typography fontSize={14} fontWeight={700} color="#1e293b" lineHeight={1.4} sx={{ wordBreak: 'break-word' }}>
                      {work || "—"}
                    </Typography>
                  </Box>

                  <Box sx={{ minWidth: 0 }}>
                    <Typography fontSize={11} sx={{ color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 700, mb: 0.5 }}>
                      File Category
                    </Typography>
                    <Box sx={{ mt: 0.2 }}>
                      <Chip 
                        label={category || "General"} 
                        size="small" 
                        sx={{ 
                          fontWeight: 700, 
                          fontSize: 12, 
                          bgcolor: '#eff6ff', 
                          color: '#2563eb', 
                          border: '1px solid #bfdbfe',
                          borderRadius: '6px'
                        }} 
                      />
                    </Box>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", gap: 1.5, flexShrink: 0, alignItems: 'center' }}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      const committerName = auth?.first_name 
                        ? `${auth.first_name} ${auth.last_name || ''}`.trim() 
                        : (auth?.username || "Work Manager");
                      setDefV({
                        repo_name: client, 
                        is_first_commit: true,
                        commit_message: "Initial commit",
                        email: auth?.email || auth?.username, 
                        username: committerName,
                        author: committerName,
                        category: category,
                        object_id: object_id
                      });
                      setOpen(true);
                    }}
                    sx={{
                      height: '40px',
                      px: 2.5,
                      borderRadius: '8px',
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '13px',
                      background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
                      boxShadow: '0 2px 4px rgba(37, 99, 235, 0.25)',
                      whiteSpace: 'nowrap',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #1d4ed8, #1e40af)',
                      }
                    }}
                  >
                    Upload New Document
                  </Button>

                  <Button
                    variant="outlined"
                    onClick={() => { navigate(backUrl || "/works/") }}
                    sx={{
                      height: '40px',
                      px: 2.5,
                      borderRadius: '8px',
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '13px',
                      borderColor: '#cbd5e1',
                      color: '#475569',
                      whiteSpace: 'nowrap',
                      '&:hover': {
                        borderColor: '#94a3b8',
                        bgcolor: '#f8fafc'
                      }
                    }}
                  >
                    Back →
                  </Button>
                </Box>
              </Box>
              {commitallState?.loading ? (
                <NoData loading={true} loadingTitle="Loading Documents..." loadingMessage="Please wait while we retrieve the files from repository." />
              ) : !commitallState?.data?.results || commitallState?.data?.results?.length === 0 ? (
                <NoData title="No Documents Found" message="There are currently no documents to display in this repository." />
              ) : (
                <>
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: {
                        xs: '1fr',
                        sm: 'repeat(2, 1fr)',
                        md: 'repeat(2, 1fr)',
                        lg: 'repeat(3, 1fr)'
                      },
                      gap: 2.5,
                      width: '100%'
                    }}
                  >
                    {commitallState?.data?.results?.map((data, i) => {
                      return (
                        <Box 
                          key={data.id || i}
                          className="card-bg shadow" 
                          sx={{ 
                            borderRadius: 3, 
                            p: 2.5, 
                            border: '1px solid #e2e8f0',
                            bgcolor: '#ffffff',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            height: '100%'
                          }}
                        >
                          <Box>
                            <Box sx={{ pb: 1.5, mb: 1.5, fontSize: 15, fontWeight: 800, color: '#0f172a', borderBottom: "1px solid #f1f5f9", wordBreak: 'break-word' }}>
                              📄 {data.original_filename}
                            </Box>
                            <Box sx={{ py: 0.5, fontSize: 13, fontWeight: 700, color: '#334155', wordBreak: 'break-word' }}>💼 Work: {work || "—"}</Box>
                            <Box sx={{ py: 0.5, fontSize: 13, fontWeight: 700, color: '#1e293b', wordBreak: 'break-word' }}>✨ {data.commit_message}</Box>
                            <Box sx={{ py: 0.5, fontSize: 13, color: '#64748b', wordBreak: 'break-all' }}>📁 File location: {data.repo_name}</Box>
                            <Box sx={{ py: 0.5, fontSize: 13, color: '#64748b' }}>📅 Created on: {data.created_at?.split("T")[0]}</Box>
                            <Box sx={{ py: 0.5, fontSize: 12, color: '#94a3b8', wordBreak: 'break-all' }}>🔑 File key: {data.base_commit}</Box>
                          </Box>

                          <Box sx={{ mt: 2 }}>
                            <hr style={{ border: 'none', borderTop: '1px solid #f1f5f9', marginBottom: '12px' }} />
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1.2 }}>
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => { downloadFile(data.id, data.base_commit, data.original_filename) }}
                                sx={{ textTransform: 'none', fontSize: 12, fontWeight: 600, borderRadius: '6px', borderColor: '#cbd5e1', color: '#334155' }}
                              >
                                Download Last Version
                              </Button>
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() => { setDefV(data); setOpen(true) }}
                                sx={{ textTransform: 'none', fontSize: 12, fontWeight: 600, borderRadius: '6px' }}
                              >
                                Upload Updated Document
                              </Button>
                              <Button
                                variant="outlined"
                                color="primary"
                                size="small"
                                onClick={() => { getHistory(data.id) }}
                                sx={{ textTransform: 'none', fontSize: 12, fontWeight: 600, borderRadius: '6px' }}
                              >
                                History ({data.history_count || data.history?.length || 1})
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Pagination
                      count={Math.ceil(commitallState?.data?.count / pageSize)}
                      page={page}
                      onChange={(e, value) => setPage(value)}
                      color="primary"
                    />
                  </Box>
                </>
              )}
            </>
          )}
          {view === 2 && (
            <XTable
              head={tableHeadings}
              rows={tableRows}
              onEdit={(row) => {
                // Find the original project data from the full results
                const originalData = commitallState?.data?.results.find(
                  (project) => project.id === row.id
                );

                // Set the form's default values and open the form
                if (originalData) {
                  setDefV(originalData);
                  setOpen(true);
                }
              }}
              onDelete={handleDelete}
            />
          )}
          {view === 4 && <MoreInfo
            data={{
              ...defV,
              active: defV.active ? "Yes" : "No",
              verify: defV.verify ? "Yes" : "No",
            }}

            skip={['country', 'description', 'error_email', 'no_users', 'owner', 'image']}
            group={['', 'project_name', 'created_at',]}
            icons={{ project_image: <BsCopy /> }}
            css={{ project_image: { color: '#1976d2' } }}
            onClose={() => { setView(1) }} />}

        </Container>}

    </>
  )
}